module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/trash_hover.0a4dac27.svg";